import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  fetchBunkerFreshWater,
  updateBunkerFreshWater,
  deleteBunkerFreshWater,
  addBunker,
  moveBunker,
} from "../../apis/bunkerFreshWater";

import type { BunkerPayload } from "../../utils/types/bunkerFreshWater";

export const fetchBunkerFreshWaterData = createAsyncThunk(
  "bunkerFreshWater/fetchBunkerFreshWaterList",
  async (
    { berthId, jobId }: { berthId?: string; jobId: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await fetchBunkerFreshWater(berthId, jobId);
      return {
        data: response,
        jobId,
      };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  }
);

export const updateBunkerFreshWaterData = createAsyncThunk(
  "bunker/updateBunker",
  async (
    {
      id,
      berthId,
      jobId,
      data,
    }: {
      id: string;
      berthId?: string;
      jobId?: string;
      data: { [key: string]: any; bunkersFreshWaterId: string };
    },
    { rejectWithValue }
  ) => {
    try {
      await updateBunkerFreshWater(id, berthId, jobId, data);
      return { success: true, data, berthId, jobId, bunkerFreshwaterId: id };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  }
);

export const deleteBunkerData = createAsyncThunk(
  "bunker/deleteBunker",
  async (
    { id, berthId, jobId }: { id: string; berthId: string; jobId: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await deleteBunkerFreshWater({ id, berthId });
      if (response.success) {
        return { bunkersFreshWaterId: id, jobId, success: true };
      }
      return rejectWithValue("Unknown error… Please try again");
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  }
);

export const addBankerFreshWaterData = createAsyncThunk(
  "banker/addBunker",
  async (
    { data, jobId }: { data: BunkerPayload; jobId: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await addBunker(data);
      return {
        data: response,
        jobId,
      };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  }
);

export const moveBunkerData = createAsyncThunk(
  "cargo/moveBunker",
  async (
    {
      id,
      berthId,
      jobId,
    }: {
      id: string;
      berthId: string;
      jobId: string;
    },
    { rejectWithValue }
  ) => {
    try {
      await moveBunker(id, berthId);
      return { success: true, id, jobId,data: { berthId } };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  }
);
